(function () {
  "use strict";

  HomeTileCtrl.$inject = ['$scope', 'trainerPrivilege'];
  angular
    .module('trainerWebApp.controllers')
    .controller('HomeTileCtrl', HomeTileCtrl);

  function HomeTileCtrl($scope, trainerPrivilege) {
    $scope.tileSpecialItems = {
      freeContent: {type: 'free'}
    };

    var homeTileState = $scope.homeTileState = {
      permissions: {
        canViewFreeContent: true,
        canCreateCourses: true
      },
      statuses: {
        series: {name: 'Series', icon: 'icon-copy'},
        draft: {name: 'Draft Course', icon: 'icon-circle'},
        active: {name: 'Active Course', icon: 'icon-circle'},
        archive: {name: 'Archived Course', icon: 'icon-circle'}
      },
      specialItems: {
        freeContent: {type: 'free'}
      },
      view: {
        showFreeContent: true,
        showCreateCourse: true
      }
    };
    var userRole = trainerPrivilege.roles();

    function setup() {
      homeTileState.permissions.canCreateCourses = userRole.canEditCourses;
      homeTileState.permissions.canViewFreeContent = userRole.canEditCourses;
    }

    // show/hide free content and create course based on filters
    $scope.$watch('homeState.search.typeFilter', function (value) {
      calcCreateCourseTileVisibility();
      calcFreeContentTileVisibility();
    });

    $scope.$watch('homeState.search.statusFilter', function (value) {
      calcFreeContentTileVisibility();
    });

    $scope.$watch('homeState.search.compositeSearchFilter', function (value) {
      calcCreateCourseTileVisibility();
      calcFreeContentTileVisibility();
    });

    function calcCreateCourseTileVisibility() {
      var s = $scope.homeState.search;

      if (s.compositeSearchFilter) {
        homeTileState.view.showCreateCourse = false;
        return;
      }

      homeTileState.view.showCreateCourse = !!~['all', 'online'].indexOf(s.typeFilter);
    }

    function calcFreeContentTileVisibility() {
      var s = $scope.homeState.search;

      if (s.compositeSearchFilter) {
        homeTileState.view.showFreeContent = false;
        return;
      }

      if (!~['all', 'online'].indexOf(s.typeFilter)) {
        homeTileState.view.showFreeContent = false;
        return;
      }

      if (!~['all', 'draft'].indexOf(s.statusFilter)) {
        homeTileState.view.showFreeContent = false;
        return;
      }

      homeTileState.view.showFreeContent = true;
    }

    setup();
  }

})();
